import { forwardRef } from "react";

import { cn } from "@/lib/utils";

export const Row = forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ children, className, ...props }, ref) => {
  return (
    <div ref={ref} className={cn("flex", className)} {...props}>
      {children}
    </div>
  );
});

Row.displayName = "Row";
